var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 41,
    viewBox: "0 0 37 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7222 1.4758V34.2376H16.4583V1.4758H10.7222Z",
    fill: "#630031",
    stroke: "#630031"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2639 1.4758V34.2376H36V1.4758H30.2639Z",
    fill: "#630031",
    stroke: "#630031"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8073 15.0581H16.4583V17.4462H30.2639L25.8073 15.0581Z",
    fill: "#630031",
    stroke: "#630031"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.78809V39.5242H6.73611V5.78809H1Z",
    fill: "#CF4420",
    stroke: "#CF4420"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5416 5.78809V39.5242H26.2777V5.78809H20.5416Z",
    fill: "#CF4420",
    stroke: "#CF4420"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0851 23.4825H6.73608V26.5937H20.5416L16.0851 23.4825Z",
    fill: "#CF4420",
    stroke: "#CF4420"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9bf87bb25c29967d11f3ef079cbe1afb.svg";
export { ForwardRef as ReactComponent };